<script lang="ts" setup>
  import type { TypeGroupBookingObeeComponent } from '~/types/contentful'

  defineProps<{
    data: TypeGroupBookingObeeComponent<'WITHOUT_UNRESOLVABLE_LINKS', string>
  }>()
</script>

<template>
  <section class="m-group-booking-obee module-paddings">
    <CGroupBookingObee
      :background-color="data.fields.base?.fields.backgroundColour"
      class="m-group-booking-obee__group-booking-obee"
    />
  </section>
</template>

<style lang="scss" scoped>
  .m-group-booking-obee {
    background-color: v-bind('data.fields.base?.fields.backgroundColour');

    .m-group-booking-obee__group-booking-obee {
      margin: 0 auto;
    }
  }
</style>
